import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { recoverSchema } from "@/features/auth/schema/recoverSchema";
import { requestResetPasswordApi } from "@/features/auth/services/requestResetPassword";
import { TRecoverRequest } from "@/features/auth/types/recoverRequest";
import { AppRoutes } from "@/routes/config";
import { setErrorForm, showError } from "@/utils/error";
import { getDynamicRoute } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const RecoverForm = () => {
  const navigate = useNavigate();
  const methods = useForm<TRecoverRequest>({
    mode: "onChange",
    resolver: yupResolver(recoverSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TRecoverRequest) => {
    try {
      await requestResetPasswordApi(data);
      navigate(getDynamicRoute(AppRoutes.recoverComplete, {}, `email=${encodeURIComponent(data.email)}`));
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={recoverSchema}>
      <Stack gap={4} width={400}>
        <FormField control={control} name="email" label="メールアドレス">
          <Input size="lg" placeholder="info@irohana.co.jp" />
        </FormField>
        <Button type="submit" size="sm" fullWidth>
          送信
        </Button>
      </Stack>
    </Form>
  );
};
